import styled from 'styled-components';

const SmartBannerStyled = styled.div`
  .smartBanner {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    border-bottom: 1px solid ${(props) => props.theme.color.border} !important;
    padding: 8px 16px;

    .logo {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
    }

    .logoImage {
      border: 1px solid ${(props) => props.theme.color.border} !important;
      border-radius: 4px !important;
      padding: 2px !important;
      height: 24px !important;
      margin-right: 8px;
      width: 26px !important;
    }

    .desc {
      line-height: 1.2;
      width: auto;

      .title {
        font-size: 14px;
        font-weight: 900;
      }

      .subtitle {
        font-size: 12px;
        color: ${(props) => props.theme.grey.light};
        font-weight: 600;
      }
    }

    img {
      width: 26px !important;
      height: 16px !important;
    }

    .title {
      font-size: 12px;
      font-weight: bolder;
    }

    .btn {
      padding: 4px 8px;
      margin-right: 0;
      border-radius: ${(props) => (props.isIOS ? '16px' : '8px')};
    }
  }
  @media (max-width: 390px) {
    .smartBanner {
      height: 64px;
      padding-bottom: 20px;
    }
    .desc {
      .subtitle {
        font-size: 10px;
      }
    }
  }
`;

export default SmartBannerStyled;
